import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  UpdateTasks as UpdateTasksGenerated,
  UpdateTasksVariables as UpdateTasksVariablesGenerated,
} from "core/queries/__generated__/UpdateTasks";

export interface UpdateTasksResponse extends UpdateTasksGenerated {}
export interface UpdateTasksVariables extends UpdateTasksVariablesGenerated {}
export const updateTasks = gql`
  mutation UpdateTasks(
    $taskIds: [ID!]!
    $assigneeId: ID
    $assigneeIds: [ID!]
    $dueAt: RFC3339DateTime
    $priority: Int
    $status: TaskStatus
    $addTags: [ID!]
    $removeTags: [ID!]
  ) {
    updateTasks(
      taskIds: $taskIds
      assigneeId: $assigneeId
      assigneeIds: $assigneeIds
      dueAt: $dueAt
      priority: $priority
      status: $status
      addTags: $addTags
      removeTags: $removeTags
    ) {
      batchJob {
        action
        createdAt
        creatorId
        errors {
          task {
            id
            name
          }
        }
        id
        remaining
        status
        total
        updatedAt
      }
    }
  }
`;

interface UseUpdateTasksQueryOptions {
  refetchQueries?: string[];
  awaitRefetchQueries?: boolean;
  onCompleted?: (data: UpdateTasksResponse) => void;
}
export const useUpdateTasks = ({
  refetchQueries = [],
  awaitRefetchQueries,
  onCompleted,
}: UseUpdateTasksQueryOptions) =>
  useMutation<UpdateTasksResponse, UpdateTasksVariables>(updateTasks, {
    refetchQueries,
    awaitRefetchQueries,
    onCompleted,
  });
